export const userId = user => Number(user.user_id || user.uuid)
export const initials = user => String(user.display_name || [user.prenom, user.nom].filter(Boolean).join(' ') || '?').trim().split(/\s+/).slice(0, 2).map(x => x.charAt(0)).join('').toUpperCase()
export const displayName = user => user.display_name || [user.prenom, user.nom].filter(Boolean).join(' ') || 'Utilisateur'
export const uuid = () => {
  if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID()
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 15) | 64
  bytes[8] = (bytes[8] & 63) | 128
  const s = Array.from(bytes, x => x.toString(16).padStart(2, '0')).join('')
  return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`
}
export const presenceFor = (user, connected) => connected.find(p => userId(p) === userId(user) && (
  user.entreprise_id ? (Number(p.entreprise_id) === Number(user.entreprise_id) || (user.company_key && p.entreprise === user.company_key)) : true
))
export const activity = (presence, now = Date.now()) => {
  if (!presence) return { label: 'Hors ligne', color: 'grey', minutes: 0 }
  const since = presence.lastUpdate || (presence.lastpage && presence.lastpage.time)
  const timestamp = since ? Date.parse(String(since).replace(' ', 'T')) : now
  const minutes = Math.max(0, Math.floor((now - (Number.isFinite(timestamp) ? timestamp : now)) / 60000))
  return presence.isAfk
    ? { label: `Inactif depuis ${minutes} min`, color: minutes >= 5 ? 'orange darken-2' : 'amber darken-1', minutes }
    : { label: 'Actif', color: 'success', minutes: 0 }
}
export const conversationName = (conversation, selfId) => conversation.type === 'group'
  ? conversation.title || 'Groupe'
  : (conversation.participants.find(p => userId(p) !== Number(selfId)) || {}).display_name || 'Discussion individuelle'
export const errorMessage = error => (error.response && error.response.data && error.response.data.message) || (!error.isAxiosError && error.message) || 'La connexion au chat est momentanément indisponible.'
